module.exports = __webpack_public_path__ + "a6697644e497d10350c0993bf79dc9c7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PF.svg
// module id = YgzI
// module chunks = 0